import CallToActionContainer from '@/components/common/callToAction/CallToActionContainer';

import styles from './ModalFooter.module.scss';

const ModalFooter = ({ footer }) => (
  <div className={styles.container}>
    {footer.map(({ id, label, ...rest }) => {
      return (
        <CallToActionContainer
          key={id}
          id={id}
          fullWidth
          {...rest}
        >
          {label}
        </CallToActionContainer>
      );
    })}
  </div>
);

export default ModalFooter;
